import React, { useCallback } from "react";
import EventResults from "./EventResults";
import {
  AccountingEventsGroup,
  CanonicalBusinessEvent,
  DigitalBusinessDocument,
  DigitalCostDocument,
} from "../../types";
import { getEventVersion } from "../../helpers/typeChecks";
import VersionSelector from "../common/VersionSelector";

interface Props {
  eventData: (
    | AccountingEventsGroup
    | DigitalBusinessDocument
    | DigitalCostDocument
    )[];
  cbeData?: CanonicalBusinessEvent[];
  onVersionChange: (index: number) => void;
}

export default function EventsVersionSelector(props: Props) {
  const { eventData, cbeData, onVersionChange } = props;

  const handleVersionChange = useCallback(
    (index: number) => {
      onVersionChange(index);
    },
    [onVersionChange]
  );

  const renderTabContent = useCallback(
    (
      items: (
        | AccountingEventsGroup
        | DigitalBusinessDocument
        | DigitalCostDocument
        )[]
    ) => {
      return <EventResults eventData={items[0]} cbeData={cbeData} />;
    },
    [cbeData]
  );

  const renderTabLabel = useCallback((version: number) => {
    return `Version ${version}`;
  }, []);

  return (
    <VersionSelector
      data={eventData}
      getVersion={getEventVersion}
      renderTabLabel={renderTabLabel}
      renderTabContent={renderTabContent}
      onVersionChange={handleVersionChange}
    />
  );
}
